export const userPreferencesModal = 'userPreferencesModal';
